import AbstractPageController from './AbstractPageController';
import Logger from '../utils/Logger';
import { css } from '../utils/CssUtils';

export default class MasterController extends AbstractPageController {
    constructor(...args) {
        super(...args);
        Logger.log('MasterController->constructor()');

        this.initDomElements();
        this.addEventListeners();
        this.ready();
    }

    initDomElements() {
        this.$container = this.app.$body.querySelector('.u-container');
        this.$dock = this.app.$body.querySelector('.c-dock');
    }

    addEventListeners() {
        if (this.$container && this.$dock) {
            this.app.addListener('dock-height-update', this.updateContainerPaddingBottom.bind(this));
        }
    }

    updateContainerPaddingBottom() {
        if (this.app.isBreakpointUp('md')) {
            if (this.$dock) {
                const dockHeight = this.$dock.getBoundingClientRect().height;
                css(this.$container, { 'padding-bottom': dockHeight + 'px' });
            } else {
                css(this.$container, { 'padding-bottom': null });
            }
        } else {
            css(this.$container, { 'padding-bottom': null });
        }
    }

    update() { }

    destroy() { }
}
